import React from 'react';

import * as S from './styles';
import ScheduleInfoDynamicPage from 'components/ScheduleInfoDynamicPage';
import WaitingForDataDynamicPage from 'components/WaitingForDataDynamicPage';
import { DataFormProps } from 'components/FormDynamicPageSelected/Forms/InputsSingleProduct';
import { ItemDynamicPageInPhone } from 'types/ItemDynamicPageInPhone';
import CardProduct from 'components/CardProduct';
interface SingleProductProps {
	item: ItemDynamicPageInPhone;
}

export default function SingleProduct({ item }: SingleProductProps) {
	const { data } = item;

	const dataAbouItem: DataFormProps = data;

	return Object.keys(item.data).length === 0 ? (
		<WaitingForDataDynamicPage />
	) : (
		<S.container>
			{(dataAbouItem.schedule_start !== '' ||
				dataAbouItem.schedule_end !== '') && (
				<ScheduleInfoDynamicPage
					countdown={dataAbouItem.countdown}
					endDate={dataAbouItem.schedule_end}
					startDate={dataAbouItem.schedule_start}
				/>
			)}

			{dataAbouItem.product ? (
				<CardProduct product={dataAbouItem.product} isHeartInFashion={false} />
			) : (
				<S.noProduct>
					<p>Não há produto</p>
				</S.noProduct>
			)}
		</S.container>
	);
}
